<template>
  <div class="single-answer">
    <div class="q-privew">
      <div class="q-number" v-if="currentQuestion.questionNo">Q {{currentQuestion.questionNo}}</div>
      <div @contextmenu="rightClickDisable($event)"  @mouseup="rightClickDisable($event)" class="q-type"  :class="{'question-font':!questionFont(currentQuestion)}" v-html="currentQuestion.question_text"></div>
    </div>
    
    <div class="question-part">
      <div v-for="(opt,opIndex) in currentQuestion.options" :key="opIndex" class="que-row">
        <div class="que-col-1">
          <span class="opction-text">{{opt.index}}</span>
          <div class="private-radio" v-if="showAnswerField">
            <input type="radio" @change="onRadioChange(opt)" :disabled="currentQuestion.disabled" :checked="isChecked(opt)" color="red" />
            <i
              v-if="isChecked(opt)"
              aria-hidden="true"
              class="v-icon notranslate mdi mdi-radiobox-marked theme--light red--text"
            ></i>
            <i
              v-else
              aria-hidden="true"
              class="v-icon notranslate mdi mdi-radiobox-blank theme--light"
            ></i>
          </div>
        </div>
        <div class="que-col-2">
          <div v-html="opt.option_text"   :class="{'option-font':!optionFont(opt)}"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "AssertionReason",
  props: ["currentQuestion", "showAnswerField"],
  data() {
    return {};
  },
  methods: {
    onRadioChange(opt) {
      if (this.currentQuestion.parent_id) {
        this.$parent.currentQuestion.isAnswered = true;
      } else {
        this.currentQuestion.isAnswered = true;
      }
      this.currentQuestion.options = this.currentQuestion.options.map(x => {
        if (opt.index === x.index) {
          x.correct_answer = true;
        } else {
          x.correct_answer = false;
        }
        return x;
      });
    },
    rightClickDisable(e) {
      e.preventDefault();   
    },
  }
};
</script>